
import { ref, unref, defineComponent, onUnmounted, onMounted } from 'vue';
import { useRoute } from 'vue-router'

/* Stores */
import { useAppStore } from '@/store/app'

/* 组件 */
import { useWatermark } from '@/hooks/useWatermark'
import { DocumentEditor, IConfig } from "@onlyoffice/document-editor-vue"

/* Apis */
import { GetDocConfigApi } from '@/apis/attachment/attachment.api'

export default defineComponent({
    components: { DocumentEditor },
    setup() {

        const login = useAppStore().getLoginInfo
        const { setWatermark } = useWatermark()

        const { query } = useRoute()

        const isConfigLoaded = ref(false);
        const configData = ref<IConfig | any>()
        const docJsFile = ref<string>('https://office.voion.com/ds-vpath/')

        async function loadingConfig() {

            const _res = await GetDocConfigApi(query.fileId as string, "view")

            _res.data.type = 'mobile'

            configData.value = _res.data
            isConfigLoaded.value = true;
        }

        const methods: {
            onAppReady: () => void
            requestHistory: (event: any, pr: any) => void
            requestHistoryData: (event: any, pr: any) => void
        } = {

            onAppReady: () => {
                setWatermark(`${login.user_name}(${login.user_account})`)
            },

            requestHistory: (event: any, pr: any) => {
            },

            requestHistoryData: (event: any, pr: any) => {
            }
        }

        onMounted(() => {
            loadingConfig()
        })

        return () => (
            <div style="width:100%; height:100%">
                {!unref(isConfigLoaded) ?
                    (<div v-loading="true" element-loading-text="正在加载文档，请稍后" element-loading-background="rgba(122, 122, 122, 0.3)" style="width:100%; height:100%"></div>)
                    : (<DocumentEditor id="docEditor" type='mobile' documentServerUrl={unref(docJsFile)} config={unref(configData)} events_onAppReady={methods.onAppReady} />)
                }
            </div>
        )

    },
    mounted() {
        onUnmounted(() => { })
    },

})

